import { computed } from '@ember/object';
import FirstOrderActualFilterAmplitude from '../common/actual-filter-amplitude';
import * as Complex from '../../../process-data/complex';

export default FirstOrderActualFilterAmplitude.extend({
  c1: null,
  r1: null,
  complexAlphaPlus: computed('c1', 'r1', 'sImaginary', function () {
    var sImaginary = this.sImaginary;
    var complexOne = Complex.createComplex(1, 0);
    var r1 = this.r1;
    var c1 = this.c1;

    var result = complexOne.divide(Complex.createComplex(1, r1 * c1 * sImaginary));
    return result;
  }),
});
